import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TimelineService {

  constructor(
    private http: HttpClient,
  ) { }

  getSchedules(){
    return this.http.get(environment.appUrl + '/schedules');
  }

  getSchedulesDTO(fromDate: string, toDate: string){
    return this.http.get(environment.appUrl + '/schedules/trips?fromDate='+fromDate+'&toDate='+toDate);
  }
}
